import { useRef } from 'react';
import { EmojiFieldWrap } from '../ui/EmojiPicker';
import FileDropZone from '../ui/FileDropZone';
import { validateFile, getAcceptAttribute, getLimitsHint } from '../../utils/fileValidation';

/** Optional note + emoji + files attached when referring a ticket. */
export default function ReferralNoteComposer({ user, note, setNote, files, setFiles, addToast }) {
  const taRef = useRef(null);

  const addFile = async (f) => {
    if (!f) return;
    const validationError = validateFile(f, user?.type, files);
    if (validationError) { addToast(validationError, 'error'); return; }
    const dataUrl = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (ev) => resolve(ev.target.result);
      reader.readAsDataURL(f);
    });
    setFiles((prev) => [...prev, { file_name: f.name, data_url: dataUrl, size: f.size }]);
  };

  return (
    <div style={{ background: '#fff', borderRadius: 14, border: '1px solid rgba(35,58,122,0.18)', padding: 16 }}>
      <h4 style={{ fontSize: 13, fontWeight: 700, color: '#334155', margin: '0 0 6px' }}>پیام ارجاع</h4>
      <p style={{ fontSize: 11, color: '#64748b', margin: '0 0 10px', lineHeight: 1.6 }}>
        متن، ایموجی یا فایل را بنویسید؛ با انتخاب فرد، همراه تیکت برای او ارسال می‌شود.
      </p>
      <EmojiFieldWrap inputRef={taRef} value={note} onInsert={setNote}>
        <textarea
          ref={taRef}
          value={note}
          rows={3}
          placeholder="یادداشت برای گیرنده… (اختیاری)"
          onChange={(e) => setNote(e.target.value)}
          style={{
            padding: '10px 14px', paddingBottom: 44,
            border: '1.5px solid #e2e8f0', borderRadius: 8,
            fontSize: 13, fontFamily: 'inherit', resize: 'vertical', direction: 'rtl',
            outline: 'none', width: '100%', boxSizing: 'border-box',
          }}
        />
      </EmojiFieldWrap>
      <div style={{ marginTop: 10 }}>
        <FileDropZone
          onFile={addFile}
          compact
          hint="فایل را اینجا بکشید یا برای پیوست به ارجاع کلیک کنید"
          accept={getAcceptAttribute(user?.type)}
          limitsHint={getLimitsHint(user?.type)}
        />
      </div>
      {files.length > 0 && (
        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {files.map((f) => (
            <div key={f.file_name} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: '#f8faff', borderRadius: 8, border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: 16 }}>📄</span>
              <span style={{ flex: 1, fontSize: 12, color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.file_name}</span>
              <button
                type="button"
                onClick={() => setFiles((prev) => prev.filter((x) => x.file_name !== f.file_name))}
                style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14 }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
